import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Redo = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17.3911 19H8.53505C5.4797 19 3 16.5151 3 13.4532C3 10.3914 5.4797 7.9065 8.53505 7.9065H20.7122M18.1661 10.6799L21 7.83994L18.1661 5",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
